<template>
  <div v-if="mostrar" class="modal-overlay">
    <div class="modal-container">
      <!-- Cabeçalho -->
      <div class="modal-header">
        <h6>Planos a Vencer</h6>
        <i class="bi bi-x-circle close-icon" @click="$emit('fechar')" title="Fechar"></i>
      </div>

      <!-- Tabela de Planos -->
      <div class="table-container">
        <table class="table table-striped table-hover">
          <thead>
            <tr>
              <th>Matrícula</th>
              <th>Aluno</th>
              <th>Vencimento</th>
              <th class="text-center">Dias p/vencer</th>
              <th class="text-center">E-mail de renovação</th> <!-- NOVO -->
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!planos.length">
              <td colspan="5" class="text-center">Nenhum plano a vencer.</td>
            </tr>
            <tr v-else v-for="plano in planos" :key="plano.id">
              <td>{{ plano.id }}</td>
              <td>{{ plano.aluno_nome }}</td>
              <td :class="vencimentoClasse(plano.termino_vigencia)">{{ formatarData(plano.termino_vigencia) }}</td>
              <td class="text-center">{{ diasParaVencer(plano.termino_vigencia) }}</td>

              <td class="text-center">
                <span :class="emailRenovClasse(plano)">
                  {{ emailRenovTexto(plano) }}
                </span>
              </td>

              <td class="text-center">
                <i
                  class="bi bi-arrow-right-circle action-icon"
                  title="Detalhar Matrícula"
                  @click="detalhar(plano.id)"
                ></i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import globalUtils from '@/utils/globalUtils.js';

export default {
  name: 'PlanosAVencer',
  props: {
    mostrar: {
      type: Boolean,
      default: false
    },
    planos: {
      type: Array,
      default: () => []
    }
  },
  emits: ['fechar'],
  methods: {
    formatarData(data) {
      return data ? globalUtils.formatarData(data) : '-';
    },
    vencimentoClasse(data) {
      if (!data) return '';
      const hoje = new Date();
      const termino = new Date(data.split('T')[0] + 'T00:00:00');
      const diffDias = (termino - hoje) / (1000 * 60 * 60 * 24);
      return diffDias <= 30 ? 'text-danger' : 'text-primary';
    },
    diasParaVencer(data) {
      if (!data) return '-';
      const hoje = new Date();
      const termino = new Date(data.split('T')[0] + 'T00:00:00');
      const diffMs = termino - hoje;
      const dias = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
      return dias >= 0 ? dias : 0;
    },
    emailRenovTexto(plano) {
      const d = plano.email_renov_enviado_em;
      return d ? `Enviado em ${globalUtils.formatarData(d)}` : 'Não enviado'
    },
    emailRenovClasse(plano) {
      return plano.email_renov_enviado_em ? 'text-success' : 'text-danger';
    },

    detalhar(id) {
      this.$emit('fechar');
      this.$router.push({ name: 'DetalharMatriculas', params: { id } });
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-container {
  background: #fff;
  width: 100%;
  max-width: 600px;
  max-height: 80vh;
  overflow-y: auto;
  border-radius: 4px;
  z-index: 2001;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background: #f1f1f1;
  border-bottom: 1px solid #ddd;
}

.close-icon {
  font-size: 1.5rem;
  cursor: pointer;
}

.table-container {
  padding: 15px;
}

.table th,
.table td {
  vertical-align: middle;
}

.action-icon {
  cursor: pointer;
  font-size: 1.2rem;
  color: #007bff;
}

.action-icon:hover {
  color: #0056b3;
}

.text-danger { color: #dc3545; }
.text-primary { color: #0d6efd; }
</style>
